var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArchive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 2,5.33 A 2.22,2.22 0 0,1 4.22,3.11 L 19.78,3.11 A 2.22,2.22 0 0,1 22,5.33 L 22,5.33 A 2.22,2.22 0 0,1 19.78,7.56 L 4.22,7.56 A 2.22,2.22 0 0,1 2,5.33",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 4.22,7.56 L 4.22,18.67 A 2.22,2.22 0 0,0 6.44,20.89 L 17.56,20.89 A 2.22,2.22 0 0,0 19.78,18.67 L 19.78,7.56",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.78,12 L 14.22,12",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArchive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/archive.b33938b8.svg";
export { ForwardRef as ReactComponent };